module.exports = __webpack_public_path__ + "static/media/donor-default-image.ab180161.png";